export default "__VITE_ASSET__BMZEXmNi__"